// Import required libraries
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./msalConfig";

// Import custom components
import App from "./js/App";

// Import styles
import "./index.scss";

// Import store
import store from "./js/redux/storeFactory";
import "./web.config";

window.React = React;
window.store = store;
const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </Provider>
  </BrowserRouter>,
  document.getElementById("root")
);
